import React, {Component} from 'react';
import {connect} from 'react-redux';
import { push } from 'react-router-redux';
import api from '../../api';
import Modal from '../../components/Modal';
import ClientContactForm from '../../components/ClientContactForm';
import roles, {isPartnerUserRoleId} from '../../constants/userRoles';
import UserForm from './UserForm';

@connect(
    (state) => ({
        isSavinguser: state.modal.isSavinguser,
        user: state.auth.user,
    }),
    {push}
)
export default class CreateUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSaving: false            
        };
    }
    getFormData() {
        var contactFormIsValid = this.refs.contactForm.isValid();
        var userFormIsValid = this.refs.userForm.isValid();
        if(contactFormIsValid && userFormIsValid) {
            this.submit(
                this.refs.userForm.getFormData(),
                this.refs.contactForm.getFormData()
            );
        }
    }
    onUserFormSubmit(userFormData) {
        if(! this.refs.contactForm.isValid()) {
            return false;
        }

        var contactFormData = this.refs.contactForm.getFormData();

        this.submit(userFormData, contactFormData);
    }
    submit(userFormData, contactFormData) {
        this.setState({isSaving: true});

        api.post(`users/create`, {...contactFormData, ...userFormData})
            .then(response => {
                this.props.closeModal();
                this.props.push(`/team/${response.value.id}`);
            });
    }
    onContactFormSubmit(contactFormData) {
        if(! this.refs.userForm.isValid()) {
            return false;
        }

        var userFormData = this.refs.userForm.getFormData();

        this.submit(userFormData, contactFormData);
    }

    render() {
        var actionButton = this.state.isSaving ?
            (<button className="btn btn-success disabled">Saving...</button>) :
            (<button className="btn btn-success" onClick={this.getFormData.bind(this)}>Save</button>);

        var userRoles = this.props.userRoles ? this.props.userRoles : roles;

        //If user isn't admin, remove admin from roles list
        if(this.props.user.userRole.name !== 'Admin')
            userRoles = userRoles.filter(o => o.name !== "Admin");

        var isCreatingPartner = userRoles.length == 1 ? isPartnerUserRoleId(userRoles[0].id) : false;

        return (
            <Modal actionButton={actionButton} className="modal-success" title={isCreatingPartner ? "Create partner" : "Create new user"}>
                <UserForm
                    userRoles={userRoles}
                    onSubmit={this.onUserFormSubmit.bind(this)}
                    ref="userForm"
                    className="form-horizontal" />
                <h2 style={{fontWeight: 'bold', marginBottom: '15px', fontSize: '16px'}}>Contact Details</h2>
                <ClientContactForm
                    showDescription={false}
                    showEmail={false}
                    onSubmit={this.onContactFormSubmit.bind(this)}
                    ref="contactForm" />
            </Modal>
        );
    }
}


// WEBPACK FOOTER //
// ./app/components/user/UserFormModal.js